export const blockIconsPrivacyandsecurityPrivateConnectivityNew = (
	<span className='material-symbols-outlined'>private_connectivity</span>
);
